import styled from "styled-components";

export const TopDiv = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
`;

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;

export const ContainerCenter = styled.div`
  height: 100%;
  width: 100%;
  background-color: #eff1f5;
  display: flex;
  flex-direction: column;
  min-height: 600px;
  min-width: 750px;
  align-items: center;
`;

export const Header = styled.div`
  width: 96%;
  display: flex;
  align-items: center;
  height: 2.68rem;
  margin-top: 2.5rem;
  user-select: none;
`;

export const Togle = styled.div`
  width: 17.43rem;
  height: 2.68rem;
  display: flex;

  background: #ffffff;
  border: 0.07rem solid #d4d6da;
  box-sizing: border-box;
  border-radius: 0.4rem;
  align-items: center;
  position: relative;
`;

export const ToggleTest = styled.div`
  position: absolute;
  width: 49%;
  height: 85%;
  border-radius: 0.4rem;
  background-color: #40e5a0;
  left: ${({ toggleState }) => (toggleState === false ? "1%" : "50%")};
  pointer-events: none;
  z-index: 1;
  transition: 0.2s ease-out;
`;

//${({ toggleState }) =>
//  toggleState === true ? "#FFFFFF" : "#40E5A0"};

export const ToggleMinhasTarefas = styled.div`
  width: 49%;
  height: 85%;
  margin-left: 1%;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 0.95rem;
  color: #585e66;

  //animation block
  z-index: 2;
  user-select: none;
  cursor: pointer;
`;

export const ToggleTodasTarefas = styled.div`
  width: 49%;
  height: 85%;
  margin-right: 1%;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 0.95rem;
  color: #585e66;
  //animation block
  z-index: 2;
  user-select: none;
  cursor: pointer;
`;

export const InputDiv = styled.div`
  width: 20.9rem;
  display: flex;
  align-items: center;
  height: 2.68rem;
  margin-left: 2rem;
`;

export const Table = styled.div`
  width: 94%;
  align-self: center;
  display: flex;
  flex-direction: column;
  user-select: none;
`;

export const TaskList = styled.div`
  max-height: 560px;
  overflow-y: auto;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset;

  padding-bottom: 30px;
  padding-right: 4px;

  ::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: gainsboro;
    border-radius: 6px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: #7e858f; /* Original color */
    filter: brightness(0.8); /* Darkened color */

    border-radius: 6px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    transform: translateX(10px);
    margin-left: 10px;
  }
`;
